import { Slider } from '../../../../../../../common/Slider';
import { TERMS_DURATIONS_SLIDER_ID } from '../../../../../../../../constants/nodeIds';
import { getActiveDurationIdx } from '../../utils';
import { INDENTS, SLIDE_WIDTH } from '../../constants';
import { Duration } from '../Duration';
import * as React from 'react';
import { useDurations } from '../../hooks/useDurations';
import * as styles from './DurationHorizontal.css';

export const DurationHorizontal = () => {
  const { onChange, durations, selectedDurationInDays } = useDurations();

  return (
    <div className={styles.root}>
      <Slider
        id={TERMS_DURATIONS_SLIDER_ID}
        visibleSlides={durations.length}
        initialSlide={getActiveDurationIdx(durations, selectedDurationInDays)}
        slideWidth={SLIDE_WIDTH}
        indents={INDENTS}
      >
        {durations.map(({ durationInDays, discountPercent }) => (
          <Duration
            key={durationInDays}
            duration={durationInDays}
            discount={discountPercent}
            checked={selectedDurationInDays === durationInDays}
            onClick={onChange}
          />
        ))}
      </Slider>
    </div>
  );
};
